<span>
  <app-product-item-no-image
    *ngIf="!productImage"
    [product_id]="product_id"
    [category_id]="category_id"
    [hyperCategories]="hyperCategories"
    [cartProductIds]="cartProductIds"
    [groupStoreData]="groupStoreData"
    [selectedDineInTable]="selectedDineInTable"
    [orderPickup]="orderPickup"
    [dineIn]="dineIn"
    [favoriteProduct]="favoriteProduct"
    [selectedPreorderDate]="selectedPreorderDate"
  >
  </app-product-item-no-image>

  <app-product-item-image
    *ngIf="
      productImage &&
      !(
        groupStoreData &&
        groupStoreData.store_info &&
        groupStoreData.store_info.design_settings &&
        groupStoreData.store_info.design_settings.overFlowImageDesign
      )
    "
    [product_id]="product_id"
    [category_id]="category_id"
    [hyperCategories]="hyperCategories"
    [cartProductIds]="cartProductIds"
    [groupStoreData]="groupStoreData"
    [selectedDineInTable]="selectedDineInTable"
    [orderPickup]="orderPickup"
    [dineIn]="dineIn"
    [favoriteProduct]="favoriteProduct"
    [selectedPreorderDate]="selectedPreorderDate"
  >
  </app-product-item-image>

  <app-product-item-browser-overflow-image
    *ngIf="
      productImage &&
      groupStoreData &&
      groupStoreData.store_info &&
      groupStoreData.store_info.design_settings &&
      groupStoreData.store_info.design_settings.overFlowImageDesign
    "
    [product_id]="product_id"
    [category_id]="category_id"
    [hyperCategories]="hyperCategories"
    [cartProductIds]="cartProductIds"
    [groupStoreData]="groupStoreData"
    [selectedDineInTable]="selectedDineInTable"
    [orderPickup]="orderPickup"
    [dineIn]="dineIn"
    [favoriteProduct]="favoriteProduct"
    [selectedPreorderDate]="selectedPreorderDate"
  >
  </app-product-item-browser-overflow-image>
</span>
